import Vue from "vue";
import Vuex from "vuex";
import AuthModule from "./modules/auth";
import ReportsModule from "./modules/reports";
import dashboardLinks from "./dashboardLinks2";

Vue.use(Vuex);

function hasAccess(link, permissions) {
  let result = false;
  if (link.cans)
    link.cans.forEach(can => {
      if (permissions.indexOf(can) > -1) result = true;
    });
  else result = permissions.indexOf(link.can) > -1;
  return result;
}
export const store = new Vuex.Store({
  modules: {
    AuthModule,
    ReportsModule
  },

  state: {
    initialData: {
      currencies: [],
      customers: [],
      branch: {
        accounts: []
      }
    },
    currencies: [],
    dashboardLinks,
    lang: localStorage.getItem("lang") || {
      text: "EN",
      value: "en",
      dir: 'ltr'
    },
    globalSnackbar: {
      color: "success",
      show: false,
      text: ""
    }
  },

  getters: {
    lang: state => state.lang,
    currencies: state => state.currencies,
    globalSnackbar: state => state.globalSnackbar,

    getSidebarLinks() {
      let finalLinks = [];
      let allLinks = dashboardLinks;
      let permissions = store.getters["AuthModule/permissions"];
      allLinks.forEach(link => {
        if (link.children) {
          let parent = null;
          let accessibleChildren = [];
          link.children.forEach(child => {
            if (hasAccess(child, permissions)) {
              parent = link;
              accessibleChildren.push(child);
            }
          });
          if (parent) {
            parent.children = accessibleChildren;
            finalLinks.push(parent);
          }
        } else if (hasAccess(link, permissions)) finalLinks.push(link);
      });

      return finalLinks;
    }
  },

  mutations: {
    showSnackbar(state, payload) {
      state.globalSnackbar.color = payload.stateType;
      state.globalSnackbar.text = payload.text;
      state.globalSnackbar.show = payload.show;
    },

    setInitialData(state, payload) {
      state.initialData = Object.assign({}, payload);
      state.initialData.currencies = Object.values(state.initialData.currencies)
      state.currencies = payload.mapped_currencies;
    },
    setLang(state, lang) {
      state.lang = lang;
    }
  }
});